import styled, { css } from 'styled-components'

import { BRAND } from 'constants/appConstants'
import { theme } from 'utils/theme'

export const Title = styled.h1`
  text-align: ${props => props.position || 'center'};
  margin: 0;

  ${({ theme: { brand } }) =>
    brand === BRAND.ATH
      ? css`
          font-family: AzoSans;
          font-weight: 600;
          color: ${theme.colors.lightGold};
          font-size: 30px;
          line-height: 40px;
        `
      : css`
          font-family: 'Futura Std';
          font-weight: 700;
          color: ${theme.colors.white};
          font-size: 28px;
          line-height: 32px;
        `}
`
